import { z } from 'zod';

export const contributionSchema = z.object({
  amount: z.coerce.number(),
  periodicity: z.enum(['once', 'monthly', 'quarterly', 'semiannual', 'annual']),
  start_month: z.coerce.number().positive('Debe ser mayor a 0').int(),
});

export type ContributionFormValue = z.infer<typeof contributionSchema>;
